import { useGate, useStore, useStoreMap } from 'effector-react'
import { permissionModel } from '~/entities/Permission'
import { Form } from '~/entities/Role'
import { $createRoleModel, createFx, formSubmitted } from './model'

export const AddRole = () => {
  useGate(permissionModel.PermissionsGate)

  const isPermissionsLoading = useStore(
    permissionModel.fetchPermissionsFx.pending,
  )
  const permissions = useStore(permissionModel.$permissions)

  const defaultValues = useStoreMap(
    $createRoleModel,
    (createRoleModel) => createRoleModel,
  )

  const isSubmitting = useStore(createFx.pending)

  return (
    <Form
      isSubmitting={isSubmitting}
      onSuccess={formSubmitted}
      defaultValues={defaultValues}
      permissions={permissions || []}
      isPermissionsLoading={isPermissionsLoading}
      isCreating
    />
  )
}
